import { parseDateOnlyString } from '../../../_shared/functions/date-operations'

/**
 * Parses a date value (string or Date) to a Date object.
 * Uses parseDateOnlyString for string inputs to handle date-only strings correctly.
 * @param {Date | string} date The date to parse
 * @returns {Date} Date object
 */
export function parseRetainerDate(date: Date | string): Date {
  if (date instanceof Date) {
    return date
  }

  return parseDateOnlyString(date)
}

/**
 * Normalizes startDate and endDate fields on a retainer or retainer budget object.
 * Converts string dates to Date objects using parseRetainerDate.
 * @param {T} obj Object with startDate and optional endDate fields
 */
export function normalizeRetainerDates<T extends { startDate?: Date | string; endDate?: Date | string }>(obj: T): void {
  if (obj.startDate) {
    obj.startDate = parseRetainerDate(obj.startDate)
  }

  if (obj.endDate) {
    obj.endDate = parseRetainerDate(obj.endDate)
  }
}
